import { useForm } from '@mantine/form';
import { useState } from 'react';
import type { ExportDto } from '../../../util/types/ExportDto';
import {
	validateDate,
	validateNotEmpty,
	validateText,
} from '../../../util/validation/commonValidation';

export function useExportForm(defaultExportType = '') {
	const defaultFilter: ExportDto = {
		fileName: '',
		exportType: defaultExportType,
	};

	const [inputs, setInputs] = useState(defaultFilter);

	const form = useForm<ExportDto>({
		mode: 'uncontrolled',
		initialValues: defaultFilter,
		validate: {
			fileName: (value) => validateText(value, false, 'File name', 50),
			startDate: (value) => validateDate(value, false, 'Start date'),
			endDate: (value) => validateDate(value, false, 'End date'),
			exportType: (value) => validateNotEmpty(value, 'Type of export'),
			branch: (value) => validateText(value, true, 'Branch', 100),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
